/*
 * CERA — PDP behaviour: gallery, variant tiers, cross-sell tabs,
 * how-it-works cycle and the reviews slider.
 * Cart interaction (add to bag, drawer) lives in cera.js.
 */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -------------------------------------------------------- gallery ----- */

  function initGallery() {
    var gal = $('[data-cera-gal]');
    if (!gal) return;

    var slides = $$('[data-gslide]', gal);
    var thumbs = $$('[data-gi]', gal);
    var count = $('[data-cera-gcount]', gal);
    var i = 0;

    function show(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== i; });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      if (count) count.textContent = i + 1 + ' / ' + slides.length;
      var active = thumbs[i];
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      }
    }

    gal.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      if (t.dataset.gi !== undefined) { show(+t.dataset.gi); return; }
      if (t.dataset.gstep) { show(i + +t.dataset.gstep); return; }
      if (t.hasAttribute('data-cera-thumbs-more')) {
        var wrap = $('[data-cera-thumbs]', gal);
        if (wrap) wrap.scrollBy({ top: wrap.clientHeight * 0.6, behavior: reduce ? 'auto' : 'smooth' });
      }
    });

    show(0);

    // The colour swatches jump the gallery to that variant's photo, so the
    // media id has to be reachable from outside this closure.
    window.CeraGallery = {
      showMedia: function (mediaId) {
        if (!mediaId) return false;
        var at = -1;
        slides.forEach(function (s, k) {
          if (at === -1 && s.dataset.mediaId === String(mediaId)) at = k;
        });
        if (at === -1) return false;
        show(at);
        return true;
      }
    };
  }

  /* ----------------------------------------------- customer clips ----- */

  function initClips() {
    $$('[data-cera-ugcq]').forEach(function (rail) {
      var track = $('[data-cera-ugcq-track]', rail);
      if (!track) return;

      var prev = $('[data-cera-ugcq-prev]', rail);
      var next = $('[data-cera-ugcq-next]', rail);
      var cards = $$('[data-cera-ugcq-play]', rail);

      function step() {
        return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
      }

      function move(dir) { track.scrollBy({ left: dir * step() }); }
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') move(1);
        if (e.key === 'ArrowLeft') move(-1);
      });
      update();

      // A tile loops silently on its own. The badge is a real play/pause:
      // first tap gives that clip sound, the next pauses it, the next
      // resumes it.
      cards.forEach(function (card) {
        var bar = $('[data-cera-ugcq-bar]', card);
        var clip = $('video', card);
        if (!clip) return;

        if (bar) {
          clip.addEventListener('timeupdate', function () {
            var at = clip.duration ? clip.currentTime / clip.duration : 0;
            bar.style.transform = 'scaleX(' + at + ')';
          });
        }

        // The badge follows the element, not our intentions — a browser that
        // pauses the clip on its own is reflected too.
        function paint() {
          card.classList.toggle('playing', !clip.paused && !clip.muted);
          card.classList.toggle('paused', clip.paused);
        }
        clip.addEventListener('play', paint);
        clip.addEventListener('pause', paint);
        clip.addEventListener('volumechange', paint);

        function start() {
          // Only one clip talks at a time.
          cards.forEach(function (other) {
            var v = $('video', other);
            if (v && v !== clip && !v.muted) {
              v.muted = true;
              v.play();
            }
          });
          clip.muted = false;
          var played = clip.play();
          if (played && played.catch) {
            played.catch(function () {
              // Sound was refused — in a preview frame, or before the
              // browser trusts the page. Hand over the native controls
              // rather than leaving a tile that answers nothing.
              clip.controls = true;
              clip.muted = true;
              clip.play();
              paint();
            });
          }
        }

        card.addEventListener('click', function (e) {
          if (clip.controls) return;
          e.preventDefault();
          if (clip.paused) return start();
          if (clip.muted) return start();
          clip.pause();
        });

        paint();
      });
    });
  }

  /* ---------------------------------------------------------- tiers ----- */


  function initTabs() {
    var fbt = $('[data-cera-fbt]');
    if (!fbt) return;

    fbt.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tab]');
      if (!tab) return;
      e.preventDefault();
      $$('[data-tab]', fbt).forEach(function (t) {
        t.setAttribute('aria-selected', String(t === tab));
      });
      $$('[data-panel]', fbt).forEach(function (p) {
        p.hidden = p.dataset.panel !== tab.dataset.tab;
      });
    });
  }

  /* -------------------------------------------------- how it works ----- */

  function initHiw() {
    var sec = $('[data-cera-hiw]');
    if (!sec) return;

    var track = $('[data-cera-hiw-track]', sec);
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    if (!cards.length) return;

    var now = $('[data-cera-hiw-now]', sec);
    var bar = $('[data-cera-hiw-bar]', sec);
    var prev = $('[data-cera-hiw-prev]', sec);
    var next = $('[data-cera-hiw-next]', sec);

    var mq = matchMedia('(max-width: 860px)');
    var dur = parseInt(getComputedStyle(sec).getPropertyValue('--hiw-dur'), 10) || 3200;
    var cur = 0;
    var timer = null;
    var inView = false;
    var hover = false;

    function setActive(i) {
      cur = i;
      cards.forEach(function (c, k) {
        c.classList.remove('on');
        if (k === i) { void c.offsetWidth; c.classList.add('on'); }
      });
      if (now) now.textContent = String(i + 1).padStart(2, '0');
      if (bar) bar.style.transform = 'translateX(' + i * 100 + '%)';
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === cards.length - 1;
    }

    function tick() { if (!mq.matches && inView && !hover) setActive((cur + 1) % cards.length); }
    function start() { stop(); if (!reduce) timer = setInterval(tick, dur); }
    function stop() { clearInterval(timer); timer = null; }

    track.addEventListener('mouseenter', function () { hover = true; sec.classList.add('paused'); });
    track.addEventListener('mouseleave', function () { hover = false; sec.classList.remove('paused'); });
    cards.forEach(function (c, i) {
      c.addEventListener('mouseenter', function () { if (!mq.matches) setActive(i); });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          inView ? start() : stop();
        });
      }, { threshold: 0.35 }).observe(sec);
    } else {
      inView = true;
      start();
    }

    function go(i) {
      var c = cards[Math.max(0, Math.min(cards.length - 1, i))];
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      track.scrollTo({ left: c.offsetLeft - track.offsetLeft - pad, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });

    var raf;
    track.addEventListener('scroll', function () {
      if (!mq.matches) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        var best = 0;
        var bd = Infinity;
        cards.forEach(function (c, k) {
          var d = Math.abs(c.offsetLeft - track.offsetLeft - pad - track.scrollLeft);
          if (d < bd) { bd = d; best = k; }
        });
        if (best !== cur) setActive(best);
      });
    }, { passive: true });

    track.tabIndex = 0;
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(cur + 1);
      if (e.key === 'ArrowLeft') go(cur - 1);
    });

    setActive(0);
  }

  /* --------------------------------------------------- reviews rail ----- */

  function initReviews() {
    var sec = $('[data-cera-rv]');
    if (!sec) return;

    var track = $('[data-cera-rv-track]', sec);
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    if (cards.length < 2) return;

    var prev = $('[data-cera-rv-prev]', sec);
    var next = $('[data-cera-rv-next]', sec);
    var bar = $('[data-cera-rv-bar]', sec);
    var now = $('[data-cera-rv-now]', sec);

    function step() { return cards[1].offsetLeft - cards[0].offsetLeft || 1; }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var visible = Math.max(1, Math.round(track.clientWidth / step()));
      var idx = Math.min(cards.length - 1, Math.round(track.scrollLeft / step()));
      if (now) now.textContent = String(Math.min(cards.length, idx + visible)).padStart(2, '0');
      var w = (visible / cards.length) * 100;
      if (bar) {
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((100 / w) * 100 - 100) : 0) + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    }

    function move(dir) {
      var visible = Math.max(1, Math.round(track.clientWidth / step()));
      track.scrollBy({ left: dir * step() * (matchMedia('(max-width: 860px)').matches ? 1 : visible) });
    }
    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') move(1);
      if (e.key === 'ArrowLeft') move(-1);
    });

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);

    /* drag to scroll, mouse only */
    var down = false;
    var sx = 0;
    var sl = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true;
      sx = e.clientX;
      sl = track.scrollLeft;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      track.scrollLeft = sl - (e.clientX - sx);
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.style.scrollBehavior = '';
      var s = step();
      track.scrollTo({ left: Math.round(track.scrollLeft / s) * s });
      setTimeout(function () { track.style.scrollSnapType = ''; }, 450);
    });
    track.style.cursor = 'grab';

    update();
  }

  /* ------------------------------------------------------------ go ----- */

  function init() {
    initGallery();
    initClips();
    initTabs();
    initHiw();
    initReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* ---------- Quantity tiers with a colour per unit ----------
   Each tier is a number of units; each unit is its own cart line against its
   own colour variant. The hidden items[n] fields live in the markup, so this
   only keeps their values and their disabled flags in step with the screen. */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  // A page can carry more than one of these — the buy box above the fold and
  // the final CTA card — so each is wired on its own. The product page keeps
  // its old hook as well, for a template that still points at it.
  $$('[data-cera-buy], [data-cera-pdp]').forEach(wire);

  function wire(pdp) {
    if (!$('[data-cera-pack]', pdp)) return;

    var titleEl = $('[data-cera-colour-label]', pdp);
    var priceEl = $('[data-cera-price]', pdp);
    // Only the main buy box drives the sticky bar.
    var stickyPrice = pdp.hasAttribute('data-cera-pdp') ? $('[data-cera-sticky-price]') : null;
    var mixedWord = pdp.dataset.mixedWord || 'Mixed';
    var moneyFormat = pdp.dataset.moneyFormat || '{{amount}}';

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      if (moneyFormat.indexOf('no_decimals') > -1) amount = String(Math.round(cents / 100));
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }

    // Paint the tier total onto the buy button and the sticky bar. Liquid marks
    // one tier as chosen on render, so this has to run on load as well as on
    // click — otherwise the button keeps showing the single-unit price.
    function paintPrice(pack) {
      if (!pack) return;
      var total = parseInt(pack.dataset.ceraPackTotal, 10);
      if (isNaN(total)) return;
      if (priceEl) priceEl.textContent = money(total);
      if (stickyPrice) stickyPrice.textContent = money(total);
    }

    function sync() {
      var panel = $('[data-cera-slots]:not([hidden])', pdp) || $('.slots:not([hidden])', pdp);
      var picks = [];

      if (panel) {
        picks = $$('.slot', panel).map(function (slot) {
          var on = $('.sw2[aria-pressed="true"]', slot) || $('.sw2:not([disabled])', slot);
          if (!on) return null;
          on.setAttribute('aria-pressed', 'true');
          var label = $('[data-cera-slot-name]', slot);
          if (label) label.textContent = on.dataset.name;
          return { name: on.dataset.name, id: on.dataset.variant };
        }).filter(Boolean);
      }

      $$('[data-cera-slot-id]', pdp).forEach(function (input, i) {
        var pick = picks[i];
        var qtyInput = $('[data-cera-slot-qty="' + (i + 1) + '"]', pdp);
        input.disabled = !pick;
        if (qtyInput) qtyInput.disabled = !pick;
        if (pick) input.value = pick.id;
      });

      if (titleEl) {
        var names = picks.map(function (p) { return p.name; });
        var unique = names.filter(function (n, i) { return names.indexOf(n) === i; });
        titleEl.textContent = unique.length === 1 ? unique[0] : (unique.length ? mixedWord : '');
      }
    }

    pdp.addEventListener('click', function (e) {
      var pack = e.target.closest('[data-cera-pack]');
      if (pack) {
        e.preventDefault();
        $$('[data-cera-pack]', pdp).forEach(function (b) {
          var on = b === pack;
          b.setAttribute('aria-checked', String(on));
          var wrap = b.closest('[data-cera-tier-wrap]');
          if (wrap) wrap.classList.toggle('on', on);
          var panel = wrap && $('.slots', wrap);
          if (panel) panel.hidden = !on;
        });
        paintPrice(pack);
        return sync();
      }

      var sw = e.target.closest('[data-cera-swatch]');
      if (!sw || sw.disabled) return;
      e.preventDefault();
      var slot = sw.closest('.slot');
      $$('.sw2', slot).forEach(function (b) { b.setAttribute('aria-pressed', String(b === sw)); });
      sync();

      // Show that colour's own photo. Only the main buy box does this — the
      // final CTA card sits far below the gallery, and scrolling the page
      // back up under someone's finger is not what they asked for.
      if (pdp.hasAttribute('data-cera-pdp') && window.CeraGallery) {
        window.CeraGallery.showMedia(sw.dataset.media);
      }
    });

    paintPrice($('[data-cera-pack][aria-checked="true"]', pdp) || $('[data-cera-pack]', pdp));
    sync();
  }
})();